import {
  Search,
  Lock,
  Unlock,
  Mail,
  MailOpen,
  Copy,
  Check,
  X,
  Pencil,
  Trash2,
  Menu,
  Users,
  LogOut,
  Download,
  Upload,
  ChevronRight,
  ChevronLeft,
  Plus,
  AlertCircle,
  CheckCircle,
  XCircle,
  Info,
  ExternalLink,
  RefreshCw,
  Loader2,
  User,
  Settings,
  MoreVertical,
  BookOpen,
  SquareCheck,
  Bug,
  Calendar,
  Image,
  FileText,
  Play,
  Archive,
  Circle,
  History,
  UserPlus,
  Shield,
  Minus,
  ShieldCheck,
  Camera,
  FolderKanban,
  ArrowLeft,
  Inbox,
  LayoutGrid,
  Zap,
  Layers,
  Puzzle,
  ClipboardList,
  LayoutTemplate,
  ChevronDown,
} from 'lucide-react';

const DEFAULT_SIZE = 20;

// Custom SVG Eye Icons
export const EyeIcon = ({ size = DEFAULT_SIZE, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export const EyeOffIcon = ({ size = DEFAULT_SIZE, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

// Re-export with consistent naming and default props
export const SearchIcon = (props) => <Search size={DEFAULT_SIZE} {...props} />;
export const LockIcon = (props) => <Lock size={DEFAULT_SIZE} {...props} />;
export const UnlockIcon = (props) => <Unlock size={DEFAULT_SIZE} {...props} />;
export const MailIcon = (props) => <Mail size={DEFAULT_SIZE} {...props} />;
export const MailOpenIcon = (props) => <MailOpen size={DEFAULT_SIZE} {...props} />;
export const CopyIcon = (props) => <Copy size={DEFAULT_SIZE} {...props} />;
export const CheckIcon = (props) => <Check size={DEFAULT_SIZE} {...props} />;
export const CloseIcon = (props) => <X size={DEFAULT_SIZE} {...props} />;
export const EditIcon = (props) => <Pencil size={DEFAULT_SIZE} {...props} />;
export const DeleteIcon = (props) => <Trash2 size={DEFAULT_SIZE} {...props} />;
export const MenuIcon = (props) => <Menu size={DEFAULT_SIZE} {...props} />;
export const UsersIcon = (props) => <Users size={DEFAULT_SIZE} {...props} />;
export const LogOutIcon = (props) => <LogOut size={DEFAULT_SIZE} {...props} />;
export const DownloadIcon = (props) => <Download size={DEFAULT_SIZE} {...props} />;
export const UploadIcon = (props) => <Upload size={DEFAULT_SIZE} {...props} />;
export const ChevronRightIcon = (props) => <ChevronRight size={DEFAULT_SIZE} {...props} />;
export const ChevronLeftIcon = (props) => <ChevronLeft size={DEFAULT_SIZE} {...props} />;
export const PlusIcon = (props) => <Plus size={DEFAULT_SIZE} {...props} />;
export const AlertIcon = (props) => <AlertCircle size={DEFAULT_SIZE} {...props} />;
export const SuccessIcon = (props) => <CheckCircle size={DEFAULT_SIZE} {...props} />;
export const ErrorIcon = (props) => <XCircle size={DEFAULT_SIZE} {...props} />;
export const InfoIcon = (props) => <Info size={DEFAULT_SIZE} {...props} />;
export const ExternalLinkIcon = (props) => <ExternalLink size={DEFAULT_SIZE} {...props} />;
export const RefreshIcon = (props) => <RefreshCw size={DEFAULT_SIZE} {...props} />;
export const LoaderIcon = (props) => <Loader2 size={DEFAULT_SIZE} className="icon-spin" {...props} />;
export const UserIcon = (props) => <User size={DEFAULT_SIZE} {...props} />;
export const SettingsIcon = (props) => <Settings size={DEFAULT_SIZE} {...props} />;
export const MoreIcon = (props) => <MoreVertical size={DEFAULT_SIZE} {...props} />;

// Sprint board icons
export const BookOpenIcon = (props) => <BookOpen size={DEFAULT_SIZE} {...props} />;
export const SquareCheckIcon = (props) => <SquareCheck size={DEFAULT_SIZE} {...props} />;
export const BugIcon = (props) => <Bug size={DEFAULT_SIZE} {...props} />;
export const CalendarIcon = (props) => <Calendar size={DEFAULT_SIZE} {...props} />;
export const ImageIcon = (props) => <Image size={DEFAULT_SIZE} {...props} />;
export const FileTextIcon = (props) => <FileText size={DEFAULT_SIZE} {...props} />;
export const PlayIcon = (props) => <Play size={DEFAULT_SIZE} {...props} />;
export const ArchiveIcon = (props) => <Archive size={DEFAULT_SIZE} {...props} />;
export const CircleIcon = (props) => <Circle size={DEFAULT_SIZE} {...props} />;
export const HistoryIcon = (props) => <History size={DEFAULT_SIZE} {...props} />;
export const UserPlusIcon = (props) => <UserPlus size={DEFAULT_SIZE} {...props} />;
export const ShieldIcon = (props) => <Shield size={DEFAULT_SIZE} {...props} />;
export const MinusIcon = (props) => <Minus size={DEFAULT_SIZE} {...props} />;
export const ShieldCheckIcon = (props) => <ShieldCheck size={DEFAULT_SIZE} {...props} />;
export const CameraIcon = (props) => <Camera size={DEFAULT_SIZE} {...props} />;
export const FolderKanbanIcon = (props) => <FolderKanban size={DEFAULT_SIZE} {...props} />;
export const ArrowLeftIcon = (props) => <ArrowLeft size={DEFAULT_SIZE} {...props} />;
export const InboxIcon = (props) => <Inbox size={DEFAULT_SIZE} {...props} />;
export const LayoutGridIcon = (props) => <LayoutGrid size={DEFAULT_SIZE} {...props} />;
export const ZapIcon = (props) => <Zap size={DEFAULT_SIZE} {...props} />;
export const EpicIcon = (props) => <Layers size={DEFAULT_SIZE} {...props} />;
export const FeatureIcon = (props) => <Puzzle size={DEFAULT_SIZE} {...props} />;
export const RequirementIcon = (props) => <ClipboardList size={DEFAULT_SIZE} {...props} />;
export const TemplateIcon = (props) => <LayoutTemplate size={DEFAULT_SIZE} {...props} />;
export const ChevronDownIcon = (props) => <ChevronDown size={DEFAULT_SIZE} {...props} />;
